import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { HurtowniciList } from "@/features/hurtownicy/components/hurtownicy-list";
import { ensureElementVisible } from "@/lib/route-guards";

const searchSchema = z.object({
	tokenId: z.coerce.number().int().positive().optional(),
	paymentDueFrom: z
		.string()
		.regex(/^\d{4}-\d{2}-\d{2}$/)
		.optional(),
	paymentDueTo: z
		.string()
		.regex(/^\d{4}-\d{2}-\d{2}$/)
		.optional(),
});

export const Route = createFileRoute("/_auth/dokumenty/hurtownicy")({
	validateSearch: (search) => searchSchema.parse(search),
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.dokumenty.hurtownicy",
			location.pathname,
		);
	},
	component: HurtowniciList,
});
